import * as React from 'react';
import Button from '@material-ui/core/Button/Button';
import { Link } from 'react-router-dom';
import { IChildrenOnlyProps } from './ichildren-only-props';

export interface ILinkButtonProps extends IChildrenOnlyProps {
    to: string;
    className?: string;
    color?: 'inherit' | 'primary' | 'secondary' | 'default';
    variant?: 'flat' | 'outlined' | 'raised' | 'fab' | 'contained'; // copied from material
}
export const LinkButton = (props: ILinkButtonProps) => (<Button className={props.className} component={(innerProps) => 
            <Link children={innerProps.children} className={innerProps.className} to={props.to} />} color={props.color} variant={props.variant}>{props.children}
</Button>);


// WEBPACK FOOTER //
// ./src/components/link-button.tsx